import { render, staticRenderFns } from "./highlightSection.vue?vue&type=template&id=0da8ace4&scoped=true&"
import script from "./highlightSection.vue?vue&type=script&lang=js&"
export * from "./highlightSection.vue?vue&type=script&lang=js&"
import style0 from "./highlightSection.vue?vue&type=style&index=0&id=0da8ace4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da8ace4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSkeletonLoader,VTab,VTabs})
